'use strict';

var $strSlice = require('../helpers/callBound')('String.prototype.slice');

module.exports = function isPrefixOf(prefix, string) {
	if (prefix === string) {
		return true;
	}
	if (prefix.length > string.length) {
		return false;
	}
	return $strSlice(string, 0, prefix.length) === prefix;
};



//////////////////
// WEBPACK FOOTER
// /Users/yinminpan/Local Dev/business-events-tas/wp-content/themes/b-e-tas/node_modules/es-abstract/helpers/isPrefixOf.js
// module id = 133
// module chunks = 0